import { z } from 'zod';

export const feedDto = z.object({
  id: z.uuid(),
  url: z.string(),
  siteUrl: z.string().nullable(),
  title: z.string().nullable(),
  faviconUrl: z.string().nullable(),
  lastFetchedAt: z.string().nullable(),
  lastStatus: z.string().nullable(),
  failCount: z.number().int(),
  category: z.string().nullable(),
  articlesLast7Days: z.number().int().optional(),
});
export type FeedDto = z.infer<typeof feedDto>;

export const discoverBody = z.object({
  url: z.string().min(1),
});
export type DiscoverBody = z.infer<typeof discoverBody>;

export const discoveredFeed = z.object({
  feedUrl: z.string(),
  title: z.string().nullable(),
  preview: z.array(
    z.object({
      title: z.string(),
      publishedAt: z.string().nullable(),
    }),
  ),
});
export type DiscoveredFeed = z.infer<typeof discoveredFeed>;

export const subscribeBody = z.object({
  feedUrl: z.string().min(1),
  category: z.string().max(100).optional(),
  // display title known up front (e.g. from a starter pack) — used until the feed itself is fetched
  title: z.string().max(200).optional(),
});
export type SubscribeBody = z.infer<typeof subscribeBody>;

export const patchSubscriptionBody = z.object({
  category: z.string().max(100).nullable(),
});
export type PatchSubscriptionBody = z.infer<typeof patchSubscriptionBody>;

export const opmlImportResult = z.object({
  imported: z.number().int(),
  failed: z.array(z.string()),
});
export type OpmlImportResult = z.infer<typeof opmlImportResult>;
